import React, { useEffect, useState, useRef, useCallback } from "react";

import { ReactComponent as ArrowPrevIcon } from "../../assets/svg/arrow-previous.svg";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as SlotFilterIcon } from "../../assets/svg/filter-search.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as FilterCloseIcon } from "../../assets/svg/close-filter.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-outline.svg";
import { ReactComponent as SearchIcon } from "../../assets/svg/search.svg";
import { ReactComponent as EditIcon } from "../../assets/svg/edit-icon.svg";
import { ReactComponent as OfficeIcon } from "../../assets/svg/office-icon.svg";
import { ReactComponent as MoreIcon } from "../../assets/svg/more-icon.svg";
import AsyncSelect from "react-select/async";
import SearchWithAPI from "../searchbox/searchbox";
import "../../components/common/pagination.css";
import RoomImage from "../../assets/png/room-image.png";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format, parse, set } from "date-fns";
import { apiCall, apiCallAdmin } from "../../services/api-service";
import { useNavigate } from "react-router-dom";
import { Form, Button, InputGroup, Toast, ToastContainer } from "react-bootstrap";
import Header from "../common/Header";
import "./material-style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "flatpickr/dist/flatpickr.min.css";
import flatpickr from "flatpickr";
import LoaderModal from "../common/Loader.js";
import { ReactComponent as NoRecordsFound } from "../../assets/svg/no-records-found.svg";
import { useGlobal } from "../../GlobalContext.js";
import DeleteModal from "../common/delete-modal.js";
import lar from "../../assets/svg/lar.svg";
import rar from "../../assets/svg/rar.svg";
import ReactPaginate from "react-paginate";
export default function OfficeList() {
  const assetUrl = process.env.REACT_APP_ASSET_URL;
  const { selectedMenu, setSelectedMenu } = useGlobal();

  const navigate = useNavigate();

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const scrollRefs = useRef([]);
  const alertRef = useRef(null);
  const scrollLeft = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: -100, behavior: "smooth" });
    }
  };

  const scrollRight = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: 100, behavior: "smooth" });
    }
  };
  const handleClickOutside = (event) => {
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setAlertIndex(null); // Close the alert
    }
  };

  const [selectedTap, setTapValue] = useState("upcoming");
  const [selectedOffice, setOfficeValue] = useState("");
  const [selectedFloor, setFloorValue] = useState("");

  //coordinator
  const [usersOption, setUsersOption] = useState([]);

  const handleUserDropdownChange = (selectedOptions) => {
    console.log(selectedOptions);
    setUsersOption(selectedOptions);
  };
  const multiselectCustomStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#ffffff",
      borderRadius: "8px",
      border: "0.7px solid #E5E5E5",
      padding: "2px",
      fontWeight: "500",
      fontSize: "15px",
      color: "#212129",
      textAlign: "left",
      justifyContent: "flex-start",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : state.isFocused ? "#e0e0e0" : "#fff",
      color: state.isSelected ? "#fff" : "#333",
      padding: 10,
      textAlign: "left",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#F6F7F8",
      color: "#212129",
      borderRadius: "5px",
      padding: "2px 5px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#212129",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#212129",
      cursor: "pointer",
      ":hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  const readOptions = (inputValue, callback) => {
    setTimeout(async () => {
      try {
        const response = await apiCallAdmin("get", `employee/autocomplete?term=${inputValue}`);
        if (response?.status === 200 && response.data.success === true) {
          const options = response.data.suggestionlist.map((item) => ({
            value: String(item.value),
            label: String(item.label),
          }));
          callback(options);
        } else {
          callback([]);
        }
      } catch (err) {
        console.error("Error fetching user suggestions:", err);
        callback([]);
      }
    }, 1000);
  };

  const [errorMessage, setErrorMessage] = useState({ name: "", floor_count: "", open_time: "", close_time: "" });
  const [officeId, setOfficeId] = useState("");
  const [codeInputValue, setCodeInputValue] = useState("");
  const [nameInputValue, setNameInputValue] = useState("");
  const [countInputValue, setCountInputValue] = useState(0);
  const [openTimeInputValue, setOpenTimeInputValue] = useState("");
  const [closeTimeInputValue, setCloseTimeInputValue] = useState("");
  const [officeDetail, setOfficeDetail] = useState({});
  const [showPicker, setShowPicker] = useState(false);

  const [orgImage, setOrgImg] = useState("");
  const [selectedCategory, setCategoryValue] = useState("");
  const [selectedSlot, setSlotValue] = useState("30 mins");
  const [selectedBookId, setBookId] = useState([]);
  const [bookIdList, setBookIdList] = useState([]);
  const [categoryList, setCategory] = useState([]);

  const [floorList, setFloors] = useState([]);
  const [roomList, setRooms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);

  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const openModal = (id, index) => {
    setRoomIndex(index);
    setRoomId(id);
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
    setErrorMessage({ name: "", floor_count: "", open_time: "", close_time: "" });
    setOfficeId(null);
    setCodeInputValue("");
    setNameInputValue("");
    setLocationOption(null);
    setCountInputValue(0);
    setOpenTimeInputValue("");
    setCloseTimeInputValue("");
    setUsersOption([]);
  };
  const [selectedRoomId, setRoomId] = useState(-1);
  const [selectedRoomIndex, setRoomIndex] = useState(-1);
  const [upcomingCount, setUpcomingCount] = useState(0);
  const [pastCount, setPastCount] = useState(0);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [alertIndex, setAlertIndex] = useState(null);
  const [time, setTime] = useState("");
  const [rolePermissionList, setRolePermissionList] = useState([]);
  const [userType, setUserType] = useState("");

  const handleChange = (event) => {
    setTime(event.target.value);
  };
  const menuBoxInactive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center" };
  const menuBoxActive = { width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "3px solid #842234" };
  const menuColorActive = { fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#842234" };
  const menuColorInactive = { fontSize: "15px", fontWeight: "400", lineHeight: "17.17px", color: "#1E1E1E" };
  const profileName = { fontSize: "14px", fontWeight: "700", color: "#842234" };
  const title = { fontSize: "24px", fontWeight: "800", color: "#1E1E1E" };
  const subtitle = { fontSize: "15px", fontWeight: "400", color: "#81878C" };
  const roomTitle = { fontSize: "18px", fontWeight: "500", color: "#1E1E1E" };
  const seatCount = { fontSize: "13.5px", fontWeight: "400", color: "#81878C", marginTop: "8px" };
  const availableTitle = { fontSize: "12px", fontWeight: "400", color: "#81878C", marginBottom: "8px" };
  const availableName = { fontSize: "12.5px", fontWeight: "400", color: "#21272C" };
  const slotTitle = { fontSize: "13px", fontWeight: "700", color: "#1E1E1E" };
  const slotTitleSelected = { fontSize: "12px", fontWeight: "500", color: "#842234" };
  const filterTitle = { fontSize: "24px", fontWeight: "700", color: "#1E1E1E" };
  const officeTitle = { marginTop: "16px", marginBottom: "8px", fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#1E1E1E" };
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "16px 24px",
      borderRadius: "16px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      width: "677px",
      minHeight: "405px",
      textAlign: "center",
    },
  };

  const handleCategoryClick = (category) => {
    setCategoryValue(category);
  };

  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    setSelectedMenu("Offices");
    fetchOptions("");
    getRolePermission();
  }, []);
  useEffect(() => {

    fetchOptions("");

  }, [itemOffset, itemsPerPage]);
  const getRolePermission = async () => {
    const response = await apiCallAdmin("get", "get_role_permission/27");
    if (response?.status === 200 && response.data.success === true) {
      setUserType(response.data.user_type);
      setRolePermissionList(response.data.role_permission ?? []);
    } else {
      setRolePermissionList([]);
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    console.log("Searching for:", term);
    fetchOptions(term);
  }, 1000);

  const fetchOptions = async (term) => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiCall("get", "office", null, {
        params: { search: term, skip: itemOffset, limit: itemsPerPage },
      });
      if (response?.data?.success === true) {
        if (response.data.offices.length > 0) {
          setRooms(response.data.offices);
          setTotalCount(response.data.total_rec ?? 0);
          setPageCount(response.data.total_pgs);
        } else {
          setRooms([]);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const editOffice = async (id) => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiCall("get", `office/${id}`);
      if (response?.data?.success === true && response.data.office) {
        setIsOpen(true);
        setOfficeId(response.data.office.id);
        setCodeInputValue(response.data.office.code);
        setNameInputValue(response.data.office.name);
        setCountInputValue(parseInt(response.data.office.floor_count, 0));
        setOpenTimeInputValue(response.data.office.open_time);
        setCloseTimeInputValue(response.data.office.close_time);
        setLocationOption({
          label: response.data.office.location,
          value: response.data.office.location_id,
        });
        setUsersOption(response.data.office.coordinators);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const submitOffice = async () => {
    const data = {
      name: nameInputValue,
      floor_count: countInputValue,
      open_time: openTimeInputValue.slice(0, 5),
      close_time: closeTimeInputValue.slice(0, 5),
      coordinators: usersOption.filter((item) => item.value !== "").map((item) => item.value),
      location_id: locationOption != null ? locationOption.value : "",
    };

    const response = await apiCall("post", "office", data);
    if (response?.status === 200 && response.data?.success === true) {
      closeModal();
      fetchOptions("");
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
    } else if (response?.status === 400) {
      setErrorValue(response.data.error);
    }
  };

  const updateOffice = async () => {
    const data = {
      name: nameInputValue,
      floor_count: countInputValue,
      open_time: openTimeInputValue.slice(0, 5),
      close_time: closeTimeInputValue.slice(0, 5),
      location_id: locationOption != null ? locationOption.value : "",
      coordinators: usersOption.filter((item) => item.value !== "").map((item) => item.value),
    };

    const response = await apiCall("put", `office/${officeId}`, data);
    if (response?.status === 200 && response.data?.success === true) {
      closeModal();
      fetchOptions("");
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
    } else if (response?.status === 400) {
      setErrorValue(response.data.error);
    }
  };

  //office location
  const [locationOption, setLocationOption] = useState(null);

  const handleRoomDropdownChange = (option) => {
    setLocationOption(option);
  };

  const setErrorValue = async (errorMsg) => {
    setErrorMessage({
      name: errorMsg["name"] !== undefined ? errorMsg["name"][0] : "",
      floor_count: errorMsg["floor_count"] !== undefined ? errorMsg["floor_count"][0] : "",
      open_time: errorMsg["open_time"] !== undefined ? errorMsg["open_time"][0] : "",
      close_time: errorMsg["close_time"] !== undefined ? errorMsg["close_time"][0] : "",
    });
    setError(null);
  };

  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      fetchOptions();
    }
  };
  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset); // Not event.selected
    },
    [itemsPerPage]
  );
  return (
    <Container fluid className="GTWalsheimTrial px-0">
      {isOpenDelete && <DeleteModal deleteUrl={`office/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      {/* <Header selectedTab={'Offices'}/> */}

      {(checkPermission("Office - Setup", "list_permission") || userType === "A" || userType === "SA") && (
        <Row className="flex-wrap px-3" style={{ height: "calc(100vh - 68px)", overflow: "auto", scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: "center" }}>
          <Col sm={12} xl={8} style={{ padding: "16px", justifyContent: "center" }}>
            <div style={title}>Your all offices are listed here!</div>
            &nbsp;&nbsp;
            <Form>
              <Row xs={12} style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                <Col xs={8} xl={9}>
                  <Form.Group style={{ borderRadius: "100px", border: "0.6px solid #E5E5E5", overflow: "hidden" }}>
                    <InputGroup>
                      <Button variant="outline-secondary" style={{ backgroundColor: "#ffffff", border: "none", outline: "none", boxShadow: "none" }}>
                        <SearchIcon />
                      </Button>
                      <Form.Control
                        className="custom-input"
                        type="text"
                        placeholder="Search..."
                        value={searchInputValue}
                        onChange={(event) => {
                          setSearchInputValue(event.target.value);

                          handleSearch(event.target.value);
                        }}
                        style={{ border: "none", outline: "none", boxShadow: "none" }}
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col xs={4} xl={2}>
                  {(checkPermission("Office - Setup", "create_permission") || userType === "A" || userType === "SA") && (
                    <div
                      onClick={(e) => {
                        setIsOpen(true);
                      }}
                      style={{ cursor: "pointer", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                      <div style={{ fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Add office</div>
                    </div>
                  )}
                </Col>
              </Row>
            </Form>
            {roomList.map((item, roomIndex) => (
              <Row key={`${roomIndex}-room`} style={{ marginTop: "16px", paddingTop: "24px", paddingBottom: "24px", paddingRight: "32px", background: "#ffffff", borderRadius: "24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {/* <Row md={12} className="justify-content-between"> */}
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                    <div style={{ width: "48px", height: "48px", borderRadius: "100px", background: "#FFE9EE", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <OfficeIcon />
                    </div>
                    <div style={{ marginLeft: "8px" }}>
                      <div style={{ fontSize: "15px", fontWeight: "700", color: "#1E1E1E" }}>{item["name"] ?? ""}</div>
                      <div style={{ fontSize: "13px", fontWeight: "500", color: "#842234" }}>{item["code"] ?? ""}</div>
                    </div>
                  </div>
                  <div key={`${roomIndex}-more`} style={{ position: "relative" }}>
                    <MoreIcon
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setAlertIndex(roomIndex === alertIndex ? null : roomIndex);
                      }}
                    />
                    {alertIndex === roomIndex && (
                      <div ref={alertRef} style={{ position: "absolute", top: "40px", left: "50%", transform: "translateX(-50%)", backgroundColor: "#ffffff", color: "#1E1E1E", padding: "16px", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", zIndex: 1, alignItems: "end" }}>
                        <div
                          onClick={() => {
                            editOffice(item["id"]);
                          }}
                          style={{ cursor: "pointer", width: "150px", height: "36px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E", display: "flex", alignItems: "center", justifyContent: "start" }}>
                          Edit
                        </div>
                        <div
                          onClick={() => {
                            setDeleteId(item.id);
                          }}
                          style={{ cursor: "pointer", width: "150px", height: "36px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E", display: "flex", alignItems: "center", justifyContent: "start" }}>
                          Delete
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div style={{ padding: "16px", marginTop: "16px", marginLeft: "16px", marginRight: "16px", borderRadius: "24px", background: "#F5F7F9" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ fontSize: "13px", fontWeight: "400", color: "#81878C" }}>Opening time</div>

                      <div style={{ fontSize: "14px", fontWeight: "500", color: "#1E1E1E" }}>{item["open_time"] ?? "0"}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: "13px", fontWeight: "400", color: "#81878C" }}>Closing time</div>

                      <div style={{ fontSize: "14px", fontWeight: "500", color: "#1E1E1E" }}>{item["close_time"] ?? "0"}</div>
                    </div>
                  </div>

                  <div style={{ textAlign: "center", padding: "4px", marginTop: "16px", borderRadius: "24px", background: "#FFFFFF" }}>
                    <div style={{ fontSize: "13.5px", fontWeight: "500", color: "#21272C" }}>
                      Floors in Building :<span style={{ fontSize: "16px", fontWeight: "700" }}> {item["floor_count"] ?? "0"}</span>
                    </div>
                  </div>
                </div>
                {/* </Row> */}
              </Row>
            ))}
            {roomList.length === 0 && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <NoRecordsFound />
                <div style={{ marginTop: "8px", fontSize: "16px", fontWeight: "500", color: "#212129" }}>No records found</div>
                <div style={{ fontSize: "13px", fontWeight: "400", color: "#8790A1" }}>Looks like you haven’t any data to show</div>
              </div>
            )}
            {roomList.length > 0 && (<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ fontFamily: "GT Walsheim Trial Bd", fontSize: "12px", fontWeight: "500", color: "#172b4d" }}>Records per page :</div>
                <select
                  className="select3"
                  id="perpage"
                  value={itemsPerPage}
                  onChange={(event) => {
                    setItemsPerPage(event.target.value);
                    setPageCount(0)
                  }}
                  style={{ cursor: "pointer", fontFamily: "GT Walsheim Trial Rg", fontSize: "12px", fontWeight: "700", lineHeight: "18.9px", color: "#172b4d", borderRadius: "6px", border: "0.6px solid #E5E5E5", padding: "8px 7px", backgroundColor: "#FFFFFF" }}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>

              <div style={{ marginTop: '12px' }}>
                <ReactPaginate previousLabel={<img src={lar} style={{ width: "12px", height: "12px" }} alt="previous" />} nextLabel={<img src={rar} style={{ width: "12px", height: "12px" }} alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
              </div>
            </div>)}
          </Col>
        </Row>
      )}
      {isOpen && (
        <div style={modalStyle.overlay}>
          <div style={modalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                  <div style={{ paddingLeft: "4px", fontSize: "20px", fontWeight: "700", color: "#1E1E1E" }}>{officeId !== null && officeId !== "" ? "Edit Office" : "Office details"}</div>
                </div>
                <SlotCloseIcon style={{ cursor: "pointer" }} onClick={closeModal} />
              </div>
              <div style={{ textAlign: "start", paddingLeft: "4px", fontSize: "14px", fontWeight: "500", color: "#1E1E1E" }} className="custom-radio">
                {officeId !== null && officeId !== "" ? "Now you can edit below details" : "Enter below details to create new office"}
              </div>
              <div style={{ marginTop: "20px" }}>
                {officeId !== null && officeId !== "" && (
                  <div className="material-form-group">
                    <input
                      type="text"
                      id="material-input"
                      className="form-control material-input"
                      placeholder=" "
                      readOnly="true"
                      value={codeInputValue}
                      onChange={(event) => {
                        setCodeInputValue(event.target.value); // Update state with input value
                      }}
                    />
                    <label htmlFor="material-input" className="material-label">
                      Code
                    </label>
                  </div>
                )}
                <div className="material-form-group">
                  <input
                    type="text"
                    id="material-input"
                    className="form-control material-input"
                    placeholder=" "
                    value={nameInputValue}
                    onChange={(event) => {
                      setNameInputValue(event.target.value); // Update state with input value
                    }}
                  />
                  <label htmlFor="material-input" className="material-label">
                    Office name
                  </label>
                </div>
                <Form.Text style={{ textAlign: "start" }} className="text-muted">
                  {errorMessage.name !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.name}</div>}
                </Form.Text>
                <div className="material-form-group">
                  <input
                    type="number"
                    id="material-input"
                    className="form-control material-input"
                    placeholder=" "
                    value={countInputValue}
                    max={100}
                    maxLength={2}
                    onChange={(event) => {
                      if (event.target.value > 100) {
                        setCountInputValue(100);
                      } else {
                        setCountInputValue(event.target.value); // Update state with input value
                      }
                    }}
                  />
                  <label htmlFor="material-input" className="material-label">
                    Floor count
                  </label>
                </div>
                <Form.Text style={{ textAlign: "start" }} className="text-muted">
                  {errorMessage.floor_count !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.floor_count}</div>}
                </Form.Text>
                <Row>
                  <Col>
                    <div className="material-form-group">
                      <input
                        type="time"
                        id="material-input"
                        className="form-control material-input"
                        placeholder=" "
                        value={openTimeInputValue}
                        onChange={(event) => {
                          setOpenTimeInputValue(event.target.value); // Update state with input value
                        }}
                      />
                      <label htmlFor="material-input" className="material-label">
                        Open Time
                      </label>
                    </div>
                    <Form.Text style={{ textAlign: "start" }} className="text-muted">
                      {errorMessage.open_time !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.open_time}</div>}
                    </Form.Text>
                  </Col>
                  <Col>
                    <div className="material-form-group">
                      <input
                        type="time"
                        id="material-input"
                        className="form-control material-input"
                        placeholder=" "
                        value={closeTimeInputValue}
                        onChange={(event) => {
                          setCloseTimeInputValue(event.target.value); // Update state with input value
                        }}
                      />
                      <label htmlFor="material-input" className="material-label">
                        Close Time
                      </label>
                    </div>
                    <Form.Text style={{ textAlign: "start" }} className="text-muted">
                      {errorMessage.close_time !== "" && <div style={{ color: "#ff0000" }}>{errorMessage.close_time}</div>}
                    </Form.Text>
                  </Col>
                </Row>
                <Row style={{ marginTop: "16px" }}>
                  <Col>
                    <AsyncSelect isMulti cacheOptions value={usersOption} loadOptions={readOptions} onChange={(selectedOptions) => handleUserDropdownChange(selectedOptions)} defaultOptions placeholder="Search Coordinator" styles={multiselectCustomStyles} isClearable={false} />
                  </Col>
                  <Col>
                    <SearchWithAPI onDropdownChange={handleRoomDropdownChange} apiUrl={process.env.REACT_APP_ADMIN_API_URL + `get_location`} placeholder="Search location" selectedValue={locationOption !== null ? locationOption.label : ""} selectedOption={locationOption} />
                  </Col>
                </Row>

                <Row style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop: "8px" }}>
                  <div
                    onClick={(e) => {
                      closeModal();
                    }}
                    style={{ cursor: "pointer", width: "176px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#FFFFFF", border: "0.6px solid #E5E5E5" }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: "#1E1E1E" }}>Cancel</div>
                  </div>
                  <div
                    onClick={(e) => {
                      if (officeId == null || officeId === 0 || officeId === "") {
                        submitOffice();
                      } else {
                        updateOffice();
                      }
                    }}
                    style={{ cursor: "pointer", width: "176px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}>
                    <div style={{ fontSize: "14px", fontWeight: "700", color: "#FFFFFF" }}>Save</div>
                  </div>
                </Row>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <LoaderModal show={loading} />
    </Container>
  );
}
